export const CANCELLATION_PERIOD = /^-?(0|[1-9]\d*)?$/;
export const HOURLY_RATE = /([1-9][0-9]*(\.[0-9]*[1-9])?|0\.[0-9]*[1-9])/;
export const BASE_MINUTES_REGEXP = /^(\d+)?(h)?(\d+)?(m)?$/;
export const BASE_PHONE_NUMBER_REGEXP = /^(\+(\d{1,3})(\(0\))?\s*)?((\(\d{3,5}\)|\d{3,5})\s*)?(\d\s*-?\s*){3,9}$/;
export const BASE_WEBSITE_REGEXP =
  /(https?:\/\/(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]*\.\S{2,}|www\.[a-zA-Z0-9][-a-zA-Z0-9]*\.\S{2,})/;
